The context that the location suggestions will be used in.

Not all locations are accepted by all SEEK API operations.
Specifying the correct usage type ensures the returned locations are valid in the context they're consumed.

Currently two codes are defined:

- `PositionPosting` returns locations suitable for posting a position profile.
  They would typically be passed to the `postPosition` or `postPositionProfileForOpening` mutation.

- `ProactiveSourcing` returns locations suitable for proactively sourcing candidates.
  They would typically be passed to the `createUnpostedPositionProfileForOpening` mutation.
